"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    ChangeSchema: function() {
        return ChangeSchema;
    },
    diff: function() {
        return diff;
    }
});
const _lodash = require("lodash");
const _typebox = require("@sinclair/typebox");
const ChangeSchema = _typebox.Type.Object({
    path: _typebox.Type.String(),
    before: _typebox.Type.Optional(_typebox.Type.Unknown()),
    after: _typebox.Type.Optional(_typebox.Type.Unknown())
});
function diff(a, b, paths) {
    const keys = paths || Array.from(new Set([
        ...Object.keys(a),
        ...Object.keys(b)
    ]));
    return keys.map((key)=>{
        // support dot notation
        const aValue = (0, _lodash.get)(a, key);
        const bValue = (0, _lodash.get)(b, key);
        if ((0, _lodash.isEqual)(aValue, bValue)) return undefined;
        return {
            path: key,
            before: aValue,
            after: bValue
        };
    }).filter((d)=>!!d);
}

//# sourceMappingURL=diff.js.map